import { REMITTANCE_STATUS,LEAD_LOST_SUB_STATUS_ID } from "../constant";

export const getRoleTable = (translations: any) => [
  { key: 'roleName', label: translations.RuleEngine?.['Role'] || translations.commonMsg?.loading },
  { key: 'description', label: translations.RuleEngine?.['Description'] || translations.commonMsg?.loading },
  { key: 'userCount', label: translations.RuleEngine?.['User_Assigned'] || translations.commonMsg?.loading },
  { key: 'featureCount', label: translations.RuleEngine?.['Feature_Access'] || translations.commonMsg?.loading },
  { key: 'status', label: translations.commonMsg?.['status'] || translations.commonMsg?.loading },
  { key: 'edit', label: translations.commonMsg?.['edit'] || translations.commonMsg?.loading },
  { key: 'delete', label: translations.commonMsg?.['delete'] || translations.commonMsg?.loading },
];

export const getLeadTable = (translations: any) => [
  { key: 'checkbox', label: '', isCheckbox: true,dependsOn: 'isManager',showWhen: true, thClass: 'checkBoxCenter' ,tdClass: 'checkBoxDataCenter'},
  { key: 'policy_no',   label: 'Policy No.'},
  { key: 'customer_name', label: 'Customer Details'},
  { key: 'created_by_name',label: 'Created By'},
  { key: 'total_premium',  label: 'Total Premium'},
  { key: 'transaction_fee',  label: 'Transaction Fee'},
  { key: 'insurer_name',  label: 'Insurer'},
  { key: 'received_amount', label: 'Payment Received',isBalanceShow:false},
  { key: 'followup_date',  label: 'Disposition /<br/>Follow-up Date',isHtml: true,sortable: true,sortKey: 'followup'},
  { key: 'payment_id',label: 'Payment ID'},
  { key: 'payment_method_name',label: 'Payment Method'},
  { key: 'payment_status',label: 'Payment Status'},
  { key: 'source_type',label: 'Source Type', titleKey: 'source_type'},
  { key: 'oto_commission_rate',label: "OTO's <br/> Commission Rate %",isHtml: true},
  { key: 'oto_gross_profit',label: "OTO's <br/> Gross Profit %",isHtml: true},
  { key: 'assigned_user_id',label: 'Assigned To',thClass: 'assigned-to-col',dependsOn: 'isManager',showWhen: true,disableWhenSubStatus: LEAD_LOST_SUB_STATUS_ID},
  { key: 'action', label: 'Action', actions: [{ icon: 'ic-remove_red_eyevisibility',onClick: 'viewDetails'},{ icon: 'ic-Call-history',onClick: 'viewTimeline',}]},
];

export const getRemittanceTable = (translations: any) => [
  { key: 'checkbox', label: '', isCheckbox: true, thClass: 'checkBoxCenter' ,tdClass: 'checkBoxDataCenter'},
  { key: 'policy_no', label: translations.Remittance?.REMITTANCE_TABLE?.POLICY_NUMBER, module: 'remittance' },
  { key: 'plate_no', label: translations.Remittance?.REMITTANCE_TABLE?.PLATE_NUMBER, module: 'remittance' },
  { key: 'leadId', label: translations.Remittance?.REMITTANCE_TABLE?.INSURANCE_ID },
  { key: 'customer_name', label: "Customer Name" },
  { key: 'source_type', label: translations.Remittance?.REMITTANCE_TABLE?.SOURCE_TYPE },
  { key: 'insurer_name', label: translations.Remittance?.REMITTANCE_TABLE?.INSURER_NAME },
  { key: 'remittance_type', label: translations.Remittance?.REMITTANCE_TABLE?.REMITTANCE_TYPE },
  {key: 'recipient_name_and_id', label: translations.Remittance?.REMITTANCE_TABLE?.RECIPIENT_NAME_ID},
  { key: 'remittance_amount', label: 'Remittance Amount' },
  { key: 'oto_gross_profit', label: "OTO's Gross Profit" },
  { key: 'remittance_status_name', label: translations.Remittance?.REMITTANCE_TABLE?.PAYMENT_STATUS },
  { key: 'credit_terms', label: translations.Remittance?.REMITTANCE_TABLE?.CREDIT_TERM },
  { key: 'assigned_role', label: translations.Remittance?.REMITTANCE_TABLE?.ASSIGNED_TO_ROLE, dependsOn: 'isManager', showWhen: true, thClass: 'assigned-to-col' },
  { key: 'assigned_to', label: translations.Remittance?.REMITTANCE_TABLE?.ASSIGNED_TO, dependsOn: 'isManager', showWhen: true, thClass: 'assigned-to-col',disabledWhen: (row: any) => row.remittance_status == REMITTANCE_STATUS['COMPLETE'] },
  { key: 'action', label: translations.Remittance?.REMITTANCE_TABLE?.ACTION, actions: [{ icon: 'ic-remove_red_eyevisibility', onClick: 'viewRemittanceDetails' },{ icon: 'ic-Call-history',onClick: 'viewTimeline'}] },
];



